<template>
  <Layout>
    <div class="card-center">
      <div class="card">
        <h3>Sistema de Gestão Administrativa {{isHeaven ? 'Heaven' : 'Greenn' }}, Seja muito bem vindo(a)!</h3>
      </div>
    </div>
    <img class="imgDecor" src="../../assets/home.svg" alt="img" />
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

export default {
  name: 'Dashboard',
  page: {
    title: 'Dashboard',
  },
  components: { Layout },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  }
}
</script>

<style>
.card-center {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  align-items: center;
  position: relative;
  top: -54px;
}
.card-center .card {
  background: #ffffffc9;
  box-shadow: 2px 4px 10px rgba(237, 237, 240, 0.2);
  border-radius: 5px;
  padding: 60px 60px;
  border-bottom: 1px solid #00e4a0;
  border-right: 1px solid #00e4a0;
}

.card-center h3 {
  font-size: 24px;
  color: black;
}

.imgDecor {
  position: absolute;
  right: 0;
  top: 9vh;
  opacity: 0.5;
  width: 100vh;
  z-index: -20;
}
</style>
